module.exports = __webpack_public_path__ + "img/akata-witch.f8a984a0.png";